/*  COMPANIES TYPES */
export const FETCH_COMPANIES: string = "FETCH_COMPANIES";
export const FETCH_COMPANIES_SUCCESS: string = "FETCH_COMPANIES_SUCCESS";
export const SET_COMPANIES: string = "SET_COMPANIES";

/* LOADING TYPES  */
export const ACTIVE_LOADING: string = "ACTIVE_LOADING";
export const INACTIVE_LOADING: string = "INACTIVE_LOADING";
